import { createSelector } from 'reselect';
import { getSelectedAssetId } from './';

export const getAttachments = state => state.attachment && state.attachment.attachments;
export const getError = state => state.attachment && state.attachment.error;
export const getLoadingAttachment = state => state.attachment && state.attachment.loading;

export const getAllAttachments = createSelector(
  getAttachments,
  attachments => attachments && attachments.ids.map(id => attachments.entities[id])
);

export const getAttachmentForSelectedAsset = createSelector(
  getSelectedAssetId,
  getAllAttachments,
  (assetId, attachments) =>
    attachments && attachments.find(attachment => attachment.asset.id === assetId)
);

export const getAttachmentsForSelectedAsset = createSelector(
  getSelectedAssetId,
  getAllAttachments,
  (assetId, attachments) => {
    if (!attachments) return [];

    let attIds = new Set()
    const filteredAttachments = attachments.filter(attachment => {
      // Filter dupes
      if (attIds.has(attachment.id)) {
        return false;
      }
      attIds.add(attachment.id)
      return attachment.asset.id === assetId
    })

    console.log(filteredAttachments);
    return filteredAttachments.sort((a1, a2) => a1.attributes.position > a2.attributes.position);
  }
);



// WEBPACK FOOTER //
// ./src/selectors/attachment.js